// axios
import axios from 'axios'
import vueConfig from '../vue.config.js'
import router from '@/router'

const domain = "https://my.bistpay.com"
//const baseURL = "https://api.bistpay.com/"

let ax=axios.create({
  domain,baseURL:vueConfig.devServer.proxy,headers: {
    Authorization: "Bearer " + localStorage.getItem("accessToken"),
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Access-Control-Allow-Origin": "*"
 } 
})



// Add a request interceptor
ax.interceptors.request.use(
  config => {
      const token = localStorage.getItem("accessToken");
      if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
      }
      else{
        if(config.url != "/api/TokenAuth/RegisterMobile" && config.url != "/api/TokenAuth/ConfirmRegisterMobile")
        
        {//alert("token null"); 
          return new Promise((resolve, reject) => {
            //router.push({path:'/pages/login',query:{to:router.history.current.path}});
            reject("401");
          });
        }
      }
      // config.headers['Content-Type'] = 'application/json';
      return config;
  },
  error => {
      Promise.reject(error)
  });


 
export default ax;